<template>
    <!-- Header -->
    <DxToolbar style="height: 56px" class="toolbar">
        <DxItem location="before" locate-in-menu="never">
            <template #default>
                <routerVue :breadcrumbsItems="breadcrumbsItems" />
            </template>
        </DxItem>
    </DxToolbar>
    <!-- Content -->

    <div class="row pl-4">
        <div class="xs12">
            <DxDataGrid
                id="gridContainer"
                class="table-page"
                :remote-operations="true"
                :show-borders="true"
                :data-source="DanhSachDoanhNghiep"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-row-lines="true"
                ref="DanhSachDoanhNghiep"
                :toolbar="{ visible: false }"
                :loadPanel="{ showIndicator: false, showPane: false, text: '' }"
                no-data-text="Không có dữ liệu!"
                height="calc(100vh - 56px)"
                @cellHoverChanged="onCellHoverChanged"
                @selection-changed="onSelectionChanged"
                :onEditorPreparing="onEditorPreparing"
                :onToolbarPreparing="onToolbarPreparing"
                :groupPanel="{ visible: 'auto' }"
                :stateStoring="{
                    enabled: true,
                    savingTimeout: 0,
                    storageKey: 'DanhSachDoanhNghiep',
                    type: 'localStorage',
                }"
            >
                <DxHeaderFilter :visible="true" :allow-search="true" />
                <DxFilterRow :visible="true" applyFilter="onClick" />
                <DxPaging :page-size="50" />
                <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                <DxColumnFixing :enabled="true" />
                <DxSelection
                    select-all-mode="allPages"
                    show-check-boxes-mode="always"
                    mode="multiple"
                />
                <DxColumn
                    data-field="TenDoanhNghiep"
                    caption="Tên doanh nghiệp"
                    :fixed="true"
                    width="250px"
                />
                <DxColumn
                    data-field="MaSoThue"
                    caption="Mã số thuế"
                    alignment="left"
                    :fixed="true"
                    width="200px"
                />
                <DxColumn data-field="SoDienThoai" caption="Số điện thoại" />
                <DxColumn data-field="DiaChi" caption="Địa chỉ" />
                <DxColumn
                    :width="200"
                    alignment="left"
                    data-field="TenTrangThai"
                    caption="Trạng thái"
                    :fixed="true"
                    fixedPosition="right"
                />
                <DxSummary>
                    <DxTotalItem
                        column="TenDoanhNghiep"
                        summary-type="count"
                        display-format="Tổng: {0}"
                        :show-in-group-footer="true"
                        :align-by-column="true"
                    />
                </DxSummary>
                <!-- Hover button -->
                <DxColumn
                    cssClass="column-button-hover"
                    data-field="Detail"
                    caption="Trạng thái"
                    width="1"
                    cell-template="buttons-cell"
                    :fixed="true"
                    fixedPosition="right"
                ></DxColumn>
                <template #buttons-cell="{ data }">
                    <div class="buttons">
                        <DxButton
                            v-if="data.data.IdTrangThai == 1"
                            class="mx-1"
                            icon="mdi mdi-pencil"
                            @click="SuaDoanhNghiep(data.data)"
                            hint="Sửa"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.IdTrangThai == 1"
                            class="mx-1"
                            icon="mdi mdi-delete"
                            @click="XoaDoanhNghiep(data.data)"
                            hint="Xóa"
                        ></DxButton>
                    </div>
                </template>

                <DxToolbarGrid>
                    <DxItemGrid location="after" name="groupPanel" />
                    <DxItemGrid location="before" template="listButtonTemplate" />
                    <DxItemGrid location="before" name="applyFilterButton" />
                    <DxItemGrid location="before" name="columnChooserButton" />
                    <DxItemGrid location="before" template="refreshTemplate" />
                </DxToolbarGrid>
                <template #listButtonTemplate>
                    <div class="row align-center">
                        <DxButton
                            type="normal"
                            icon="mdi mdi-reload"
                            styling-mode="contained"
                            hint="Tải lại"
                            class="mx-1"
                            @click="TaiLai"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-plus-circle"
                            styling-mode="contained"
                            class="mx-1"
                            @click="TaoMoiDoanhNghiep"
                            hint="Tạo mới"
                        />

                        <DxButton
                            type="normal"
                            icon="mdi mdi-pencil"
                            styling-mode="contained"
                            class="mx-1"
                            @click="SuaDoanhNghiep(this.arrSelected[0])"
                            :disabled="arrSelected.length != 1"
                            hint="Sửa"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-delete"
                            styling-mode="contained"
                            class="mx-1"
                            :disabled="arrSelected.length != 1"
                            @click="XoaDoanhNghiep(arrSelected[0])"
                            hint="Xóa"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-file-excel"
                            styling-mode="contained"
                            class="mx-1"
                            hint="Xuất Excel"
                            @click="exportExcel"
                        />
                        <div
                            class="ml-2"
                            style="width: 1px; height: 24px; background: #03a9f4"
                        ></div>
                    </div>
                </template>
                <template #refreshTemplate>
                    <div class="row">
                        <DxButton
                            type="default"
                            styling-mode="text"
                            icon="mdi mdi-refresh"
                            hint="Khôi phục cài đặt gốc của bảng"
                            @click="onStateResetClick()"
                        />
                    </div>
                </template>
            </DxDataGrid>
        </div>
    </div>

    <DxPopup
        v-if="ifPopupXacNhanXoa"
        v-model:visible="PopupXacNhanXoa"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-close-button="false"
        :show-title="false"
        :width="488"
        height="auto"
        @hidden="onHidden('PopupXacNhanXoa')"
    >
        <PopupXacNhan :Params="ParamXacNhanXoa" @click="XacNhanXoa" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupThongTinDoanhNghiep"
        v-model:visible="PopupThongTinDoanhNghiep"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="688px"
        height="auto"
        @hidden="onHidden('PopupThongTinDoanhNghiep')"
    >
        <PopupThongTinDoanhNghiepVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>
</template>

<script>
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import routerVue from "@sonphat/common-v1/components/router.vue";
import { DxButton, DxPopup } from "devextreme-vue";
import { mapActions, mapState } from "vuex";
import PopupXacNhan from "@sonphat/common-v1/components/PopupXacNhan.vue";
import {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxHeaderFilter,
    DxSummary,
    DxPaging,
    DxTotalItem,
    DxColumnFixing,
    DxScrolling,
    DxToolbar as DxToolbarGrid,
    DxItem as DxItemGrid,
} from "devextreme-vue/data-grid";
import PopupThongTinDoanhNghiepVue from "./components/PopupThongTinDoanhNghiep.vue";
export default {
    components: {
        PopupThongTinDoanhNghiepVue,
        DxToolbar,
        DxItem,
        routerVue,
        DxButton,
        DxDataGrid,
        DxColumn,
        PopupXacNhan,
        DxPopup,
        DxSelection,
        DxFilterRow,
        DxSummary,
        DxTotalItem,
        DxColumnFixing,
        DxScrolling,
        DxToolbarGrid,
        DxItemGrid,
        DxHeaderFilter,
        DxPaging,
    },
    data() {
        return {
            NgungHoatDong: false,
            itemDangChon: null,
            DanhSachDoanhNghiep: [],
            PopupXacNhanXoa: false,
            ifPopupXacNhanXoa: false,
            ParamXacNhanXoa: {
                WidthTitle: "90%",
                Title: "Bạn có chắc chắn muốn xóa doanh nghiệp đang chọn?",
                btnLeft: "HỦY",
                btnRight: "ĐỒNG Ý",
            },
            arrSelected: [],
            breadcrumbsItems: [
                {
                    id: "breadcrums_DieuDo",
                    text: this.$t("stringRouter.QLTT"),
                    disabled: true,
                    to: "",
                },
                {
                    id: "breadcrums_DieuDo",
                    text: "Doanh nghiệp",
                    disabled: true,
                    to: "",
                },
            ],
            ifPopupThongTinDoanhNghiep: false,
            PopupThongTinDoanhNghiep: false,
        };
    },

    computed: {
        ...mapState({
            DanhSachDoanhNghiep: (state) => state.QuanLyDoanhNghiep.DanhSachDoanhNghiep,
        }),
    },

    methods: {
        hiddenPopup(name) {
            this[name] = false;
        },
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        async getData() {
            this.$refs.DanhSachDoanhNghiep?.instance.clearFilter();
            this.$refs.DanhSachDoanhNghiep?.instance.clearSelection();
            try {
                this.DanhSachDoanhNghiep = (
                    await this.$store.dispatch("DoanhNghiep/LayDanhSachDoanhNghiep")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        TaiLai() {
            this.getData();
        },
        onEditorPreparing(e) {
            this.$Helper.Common.FilterRowWhenEnter(e);
        },
        onToolbarPreparing(e) {
            e.toolbarOptions.visible = true;
        },
        onStateResetClick() {
            this.$refs.DanhSachDoanhNghiep.instance.state(null);
            setTimeout(() => {
                this.$refs.DanhSachDoanhNghiep.instance.clearFilter();
                this.$refs.DanhSachDoanhNghiep.instance.clearSelection();
                this.$refs.DanhSachDoanhNghiep.instance.clearSorting();
            }, 100);
        },
        onCellHoverChanged(e) {
            this.$Helper.Common.table({ Element: e, Buttons: true }).HoverRow();
        },
        onSelectionChanged(e) {
            this.arrSelected = e.selectedRowsData;
        },
        TaoMoiDoanhNghiep() {
            this.$store.commit("DoanhNghiep/Reset_ThongTinDoanhNghiep");
            this.showPopup("PopupThongTinDoanhNghiep");
        },
        SuaDoanhNghiep(e) {
            this.$store.commit("DoanhNghiep/Set", {
                key: "ThongTinDoanhNghiep",
                data: this.$Helper.Common.CloneData(e),
            });
            this.showPopup("PopupThongTinDoanhNghiep");
        },
        exportExcel() {
            let init = {
                Element: this.$refs.DanhSachDoanhNghiep.instance,
                FileName: "DanhSachDoanhNghiep",
                WorkSheet: "Danh Sách",
            };
            this.$Helper.Common.excel(init).Export();
        },

        XoaDoanhNghiep(data) {
            this.itemDangChon = data;
            this.showPopup("PopupXacNhanXoa");
        },
        async XacNhanXoa(bool) {
            if (bool == true) {
                try {
                    this.$startLoading;
                    const rs = await this.$store.dispatch(
                        "DoanhNghiep/XoaDoanhNghiep",
                        this.itemDangChon.IdDnvt
                    );
                    if (rs.status) {
                        this.$Helper.ThongBaoToast(
                            "success",
                            "Xóa thông tin doanh nghiệp thành công!"
                        );
                        this.getData();
                    } else {
                        this.$Helper.ThongBaoPopup({
                            message_title: "Xóa thông tin doanh nghiệp thất bại!",
                            message: rs.message,
                        });
                    }
                } catch (error) {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Xóa thông tin doanh nghiệp thất bại!",
                        message: "Lỗi hệ thống client",
                    });
                } finally {
                    this.$stopLoading;
                    this.itemDangChon = null;
                    this.PopupXacNhanXoa = false;
                }
            } else if (bool == false) {
                this.itemDangChon = null;
                this.PopupXacNhanXoa = false;
            }
        },
    },
    created() {
        this.getData();
    },
};
</script>

<style scoped></style>
